<form [formGroup]="form" *ngIf="form && checkComponent()">
  <mat-card>
    <mat-card-title>
      {{ 'LABEL.BUILDING' | translate }}
      <button class="my-bounce btn btn-primary mx-2"
        style="background-color:transparent;" (click)="clearForm('building')">
        <mat-icon class="material-icons" style="color:#293683;">restore_page</mat-icon>
      </button>
    </mat-card-title>
    <div>
      <div formGroupName="building" class="form-container">
        <app-building-extended-search *ngIf="checkVisibility('search')" class="form-subject"
          [service]="buildingService" (selected)="selSubject($event)"
          [edit]="verifyDeactivation('search')" [showAdvancedSearch]="true"></app-building-extended-search>

        <app-address-search *ngIf="checkVisibility('address_search') && this.form" [multiCompany]="true"
          [mainForm]="this.form" [businessLineCode]="this.form.get('businessLineCode')?.value" [form]="buildingForm"
          class="form-subject" [edit]="editBuildingForm()"
          [noButtonSearchCompany]="true"></app-address-search>

        <app-address-detail-form *ngIf="checkVisibility('address_detail')" [form]="buildingForm" class="form-subject"
          [disabled]="disabledBuildingForm()"></app-address-detail-form>

        <br>

        <mat-form-field appearance="fill" class="form-subject" *ngIf="checkVisibility('contactChannel')">
          <mat-label>{{ 'REQUEST.CHANNEL' | translate }}</mat-label>
          <mat-select matNativeControl formControlName="contactChannel">
            <mat-option *ngFor="let cc of contactChannels$ | async" [value]="cc.name">

              {{ 'CHANNEL.'+cc.name | translate }}

            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" class="form-subject" *ngIf="checkVisibility('origin')">
          <mat-label>{{ 'REQUEST.ORIGIN' | translate }}</mat-label>
          <mat-select formControlName="origin">
            <mat-option *ngFor="let origin of origins" [value]="origin.origin" [disabled]="origin.disabled">
              {{ 'ORIGINS.'+origin.code | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="checkVisibility('company')" appearance="fill" class="form-subject margin-top">
          <mat-label>{{ 'REQUEST.COMPANY' | translate }}</mat-label>
          <mat-select matNativeControl formControlName="company">
            <mat-option *ngFor="let company of companies" [value]="company.code">
              <strong>{{company?.name}}</strong> ({{company?.code}})
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div *ngIf="checkVisibility('find_company')" appearance="fill" class="form-subject margin-top">
          <button mat-button color="primary" (click)="cercaZonaJaka()" [disabled]="verifyDeactivation('find_company')"
            class="with-icon findCompanyButton">
            <mat-icon>search</mat-icon> <span>{{ 'ADDRESS.FIND_COMPANY' | translate }}</span>
          </button>
        </div>

      </div>
    </div>
  </mat-card>
</form>